import {z} from 'zod';

export const DirectSaleCreateFormSchema = z.object({
  directSaleVariantId: z.string(),
});

export type DirectSaleCreateForm = z.infer<typeof DirectSaleCreateFormSchema>;
